import { useTranslation } from 'react-i18next';
import { Input } from '../../ui/input';
import { cn } from '../../../lib/utils';

interface VariableRowLabelProps {
    label: string;
    required?: boolean;
    isCustom: boolean;
    editLabel?: string;
    onEditLabel?: (value: string) => void;
    disabled?: boolean;
    disabledHint?: string;
    align?: 'center' | 'start';
}

export function VariableRowLabel({
    label,
    required,
    isCustom,
    editLabel,
    onEditLabel,
    disabled,
    disabledHint,
    align = 'center',
}: VariableRowLabelProps) {
    const { t } = useTranslation();

    if (isCustom && editLabel !== undefined && onEditLabel) {
        return (
            <div className={align === 'start' ? 'self-start' : undefined}>
                <Input
                    value={editLabel}
                    onChange={(e) => onEditLabel(e.target.value)}
                    className="h-9 text-sm"
                    placeholder={t('departmentVariables.variableRow.fieldLabelPlaceholder')}
                    disabled={disabled}
                />
                {disabled && disabledHint && (
                    <p className="text-xs text-muted-foreground/60 mt-1">
                        {disabledHint}
                    </p>
                )}
            </div>
        );
    }

    return (
        <span
            className={cn(
                'text-sm text-muted-foreground',
                align === 'start' ? 'self-start pt-2' : 'self-center'
            )}
        >
            {label}
            {required && <span className="text-destructive ml-0.5">*</span>}
        </span>
    );
}
